// extracted by mini-css-extract-plugin
export default {"fieldTitle":"ProjectFormCreateModal_fieldTitle__f+GFJ","fieldBox":"ProjectFormCreateModal_fieldBox__b8TS1"};